import React, { useState, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaRegBell } from "react-icons/fa";
import logo from "../../images/logoNew.png";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";

type Role = "creator" | "head";

interface HeaderProps {
  currentRole: Role;
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentRole, onToggleSidebar }) => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [roleName, setRoleName] = useState<string>("");

  useEffect(() => {
    const storedRoleName = sessionStorage.getItem("roleName");
    if (storedRoleName) {
      setRoleName(storedRoleName);
    }
  }, []);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    sessionStorage.clear();
    navigate("/Login");
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <div className="sticky top-0 shadow-sm z-50 bg-white">
        <div className="flex justify-between items-center w-full h-[45px] px-3 sm:px-5">
          {/* LEFT */}
          <div className="flex gap-2 sm:gap-4 items-center">
            <button
              onClick={onToggleSidebar}
              className="p-2 rounded-full hover:bg-gray-100 cursor-pointer transition-colors"
              aria-label="Toggle Sidebar"
            >
              <GiHamburgerMenu className="text-[#184A84] text-lg sm:text-xl" />
            </button>

            <a
              href="https://www.ramahospital.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={logo}
                alt="Logo"
                className="h-[20px] sm:h-[25px] w-[80px] sm:w-[100px]"
              />
            </a>
          </div>

          {/* CENTER - Role Display */}
         

          {/* RIGHT */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Mobile Role Display */}
            {/* {roleName && (
              <div className="sm:hidden flex justify-end items-center bg-gradient-to-r from-[#184A84] to-[#2563EB] text-white px-3 py-1 rounded-full text-xs font-semibold">
                {roleName}
              </div>
            )} */}
            
            {/* <div className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors">
              <FaRegBell className="text-[#184A84] text-base sm:text-lg" />
            </div> */}
            <div className=" bg-gradient-to-r from-[#184A84] to-[#2563EB] text-white px-3 py-1 rounded-full text-xs font-semibold">
                {roleName}
              </div>
            <div
              onClick={handleLogoutClick}
              title="Logout"
              className="p-2 rounded-full bg-red-50 hover:bg-red-100 cursor-pointer transition-colors"
            >
              <FiLogOut className="text-red-600 text-base sm:text-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* LOGOUT CONFIRMATION MODAL */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
          <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl animate-slideUp">
            {/* Header */}
            <div className="bg-red-100 text-red-600 px-6 py-4 rounded-t-2xl">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/20 rounded-full">
                  <FiLogOut className="text-xl" />
                </div>
                <h2 className="text-xl font-bold">Confirm Logout</h2>
              </div>
            </div>

            {/* Body */}
            <div className="p-6">
              <p className="text-gray-700 text-center text-lg">
                Are you sure you want to logout?
              </p>
              <p className="text-gray-500 text-center text-sm mt-2">
                You will need to login again to access your account.
              </p>
            </div>

            {/* Footer */}
            <div className="flex gap-3 px-6 pb-6">
              <button
                onClick={handleCancelLogout}
                className="flex-1 px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-semibold transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLogout}
                className="flex-1 px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-semibold shadow-md hover:shadow-lg transition-all"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
